export default function focusSvgElement(element) {
    if (element.focus) {
        element.focus();
    }
    else {
        setTimeout(function () {
            window.HTMLElement.prototype.focus.call(element);
        }, 0);
    }
}
